import { r as registerInstance, c as createEvent, h, a as Host, d as getElement, F as Fragment } from './index-BntG-4Sv.js';
import { SubscriptionList, service, ProductInfoContextService, SecurityContextService, LicenseContextService, TrackingService, WindowService, FibonacciGenerator, ServiceProvider, MonitoringService, RepositoryContextService, RepositoryLocationContextService, RepositoryService, OntoToastrService, NamespacesService, NamespacesContextService, LanguageService, AuthenticationService, AuthorizationService, EventService, ConfigurationContextService, RuntimeConfigurationContextService, isHomePage, getCurrentRoute, navigateTo, EventName, LanguageContextService, RepositoryList, ObjectUtil, getPathName, UriUtil, REPOSITORY_ID_PARAM, openInNewTab, navigate } from '@ontotext/workbench-api';
import { L as LoggerProvider, T as TranslationService } from './translation.service-CyWR_ReZ.js';
import { H as HtmlUtil } from './html-util-C8DO915D.js';
import { D as DropdownItem } from './dropdown-item-WQYHXM0G.js';
import { R as ResourceSearchConstants } from './resource-search-constants-CY5yXafk.js';

const ontoDeprecationBannerCss = ":host{display:block}.deprecation-banner{display:flex;align-items:flex-start;gap:1rem;padding:0.3rem;background:#384252;color:#FFF}.deprecation-banner .banner-content{flex:1;text-align:center}.deprecation-banner .banner-content .banner-message{font-size:1rem}.deprecation-banner .close-button{border:none;outline:0;background:transparent;color:inherit;cursor:pointer}";

const OntoDeprecationBanner = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.closeBanner = createEvent(this, "closeBanner");
        this.onClose = () => {
            this.closeBanner.emit();
        };
    }
    render() {
        return (h(Host, { key: '86781f6417e0778a59ce08dde7be09a7a4302dc1' }, h("div", { key: '4000306e941d5d22452f550e80ebdc7dccf44f29', class: "deprecation-banner" }, h("div", { key: '94c019c2bc90ca5df3f96f005cdff7d31f0d599c', class: "banner-content" }, h("div", { key: '295097fc9c5981a409c8be095f6fd9d09b2bb405', class: "banner-message" }, h("slot", { key: '8153d3a79b453cc6bb777870a6776c973530f0dc', name: "content" }))), h("button", { key: 'cecc3239a6601d0a22b6d1635b2c10ba0ce262ca', type: "button", class: "close-button", "aria-label": "Close banner", onClick: this.onClose }, h("i", { key: '9ddf4488b5a1bba60ce40795b708fd5d0aa0a84b', class: "ri-close-line" })))));
    }
};
OntoDeprecationBanner.style = ontoDeprecationBannerCss;

const ontoFooterCss = ":host{display:block}.footer-component{padding-left:var(--main-content-rl-padding);height:1.875rem}";

const OntoFooter = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        /** List of subscriptions to manage component lifecycle */
        this.subscriptions = new SubscriptionList();
        /** Current year for copyright display */
        this.currentYear = new Date().getFullYear();
        this.productInfoContextService = service(ProductInfoContextService);
        this.securityContextService = service(SecurityContextService);
        this.licenseContextService = service(LicenseContextService);
        this.trackingService = service(TrackingService);
    }
    handleConsentGiven() {
        this.trackingService.acceptCookiePolicy()
            .then(() => {
            this.shouldShowCookieConsent = false;
            // Trigger a resize event so the layout can recalculate the navbar height now that the cookie banner is removed.
            WindowService.getWindow().dispatchEvent(new Event('resize'));
        });
    }
    render() {
        var _a, _b, _c, _d, _e;
        return (h(Host, { key: 'd78daf94ec9bf8578d4be26f7ced0040ca167147' }, h("div", { key: '5660de5835f3ff252eeb456974cb747552e0d56c', class: "footer-component" }, h("a", { key: '93d3c7957ede1fa09100e15ebe896de7c9965468', href: "http://graphdb.ontotext.com", target: "_blank", rel: "noopener noreferrer" }, "GraphDB"), "\u00A0", (_a = this.productInfo) === null || _a === void 0 ? void 0 :
            _a.productVersion, " \u2022\u00A0", h("a", { key: 'b9dbc1be7fbb251d897920e56807333a0b9e50d3', href: "http://rdf4j.org", target: "_blank", rel: "noopener noreferrer" }, "RDF4J"), "\u00A0", (_b = this.productInfo) === null || _b === void 0 ? void 0 :
            _b.sesame, " \u2022 Connectors ", (_c = this.productInfo) === null || _c === void 0 ? void 0 :
            _c.connectors, " \u2022 Ontop ", (_d = this.productInfo) === null || _d === void 0 ? void 0 :
            _d.ontop, " \u2022 Workbench ", (_e = this.productInfo) === null || _e === void 0 ? void 0 :
            _e.workbench, " \u2022 \u00A9 2002\u2013", this.currentYear, "\u00A0", h("a", { key: '662d0f1301ad57b733c0fcb579fcac380c554258', href: "http://ontotext.com", target: "_blank", rel: "noopener noreferrer" }, "Ontotext AD"), ".\u00A0", h("translate-label", { key: 'ac8f96b6824bb5bdf9159c407ed4aba4f97b58e3', labelKey: 'footer.label.all_rights_reserved' })), this.shouldShowCookieConsent && h("onto-cookie-consent", { key: '8eadfa955053ba414e9c7231e6ddc0329dc68ad2' })));
    }
    // ========================
    // Lifecycle methods
    // ========================
    connectedCallback() {
        this.subscribeToProductInfoChange();
        this.subscribeToSecurityConfigChange();
        this.subscribeToUserChange();
        this.subscribeToLicenseChange();
        this.subscribeToUserLoginStatusChange();
    }
    disconnectedCallback() {
        this.subscriptions.unsubscribeAll();
    }
    subscribeToProductInfoChange() {
        this.subscriptions.add(this.productInfoContextService.onProductInfoChanged((productInfo) => {
            this.productInfo = productInfo;
        }));
    }
    subscribeToSecurityConfigChange() {
        this.subscriptions.add(this.securityContextService.onSecurityConfigChanged(() => {
            this.setCookieConsentVisibility();
        }));
    }
    subscribeToUserChange() {
        // TODO: move to cookieService, when the authenticatedUser is available synchronously
        this.subscriptions.add(this.securityContextService.onAuthenticatedUserChanged(() => {
            this.setCookieConsentVisibility();
        }));
    }
    subscribeToUserLoginStatusChange() {
        this.subscriptions.add(this.securityContextService.onUserLoginStatusChanged(() => {
            this.setCookieConsentVisibility();
        }));
    }
    /**
     * Determines whether the cookie consent banner should be shown based on the user's authentication status, license
     * type, and cookie consent status.
     * The banner is shown if the user has not accepted the cookie policy and either has free access or is logged in,
     * provided that tracking is allowed by the license. Otherwise, the banner is hidden.
     */
    setCookieConsentVisibility() {
        var _a, _b;
        // The security config may not be loaded yet, e.g. when the component connects before the security bootstrap has
        // finished. Visibility will be recalculated by the security config subscription once the config is available.
        if (!this.securityContextService.getSecurityConfig()) {
            this.shouldShowCookieConsent = false;
            return;
        }
        if (!this.trackingService.isTrackingAllowed()) {
            this.shouldShowCookieConsent = false;
            return;
        }
        const isLoggedIn = this.securityContextService.getIsLoggedIn();
        const isFreeAccessEnabled = (_b = (_a = this.securityContextService.getSecurityConfig()) === null || _a === void 0 ? void 0 : _a.isFreeAccessEnabled()) !== null && _b !== void 0 ? _b : false;
        const cookieConsent = this.trackingService.getCookieConsent();
        if (cookieConsent) {
            this.shouldShowCookieConsent = !cookieConsent.policyAccepted && (isFreeAccessEnabled || isLoggedIn);
        }
    }
    subscribeToLicenseChange() {
        this.subscriptions.add(this.licenseContextService.onLicenseChanged(() => {
            this.setCookieConsentVisibility();
        }));
    }
};
OntoFooter.style = ontoFooterCss;

/**
 *
 * A StencilJS functional component that renders a repository item in the repository selector dropdown. It displays the repository's
 * icon, ID, and location. If no location is specified, it shows "Local" as the default. This component also allows for
 * dynamic rendering of repository details as part of a list of selectable items.
 *
 * @example
 * <SelectorItemButton repository={repository}></>
 *
 */
const SelectorItemButton = ({ repository }) => {
    return (h("div", { class: "repository-selector-dropdown-item" },
        h("i", { class: 'item-icon icon-repo-' + repository.type }),
        h("div", { class: "item-label" },
            h("div", { class: "repository-id" }, repository.id),
            h("div", { class: "repository-location" }, repository.location ? repository.location : 'Local'))));
};

const ontoHeaderCss = ":host{display:block}.header-component{display:flex;gap:0.25em;padding:0.3em 1em;font-size:1.1em;background-color:var(--gw-topnav-background)}.header-component .left-section{display:flex;align-items:center;justify-content:center;margin-right:auto}.header-component .right-section{display:flex;align-items:center;justify-content:center;gap:0.3em}.header-component .big-logo{width:180px;height:50px;cursor:pointer}";

const labelKeys$1 = {
    LOGO_LINK: 'menu.logo.link.title'
};
const OntoHeader = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        // ========================
        // Services
        // ========================
        this.UPDATE_ACTIVE_OPERATION_TIME_INTERVAL = 2000;
        this.fibonacciGenerator = new FibonacciGenerator();
        this.monitoringService = ServiceProvider.get(MonitoringService);
        this.repositoryContextService = ServiceProvider.get(RepositoryContextService);
        this.repositoryLocationContextService = ServiceProvider.get(RepositoryLocationContextService);
        this.repositoryService = ServiceProvider.get(RepositoryService);
        this.securityContextService = ServiceProvider.get(SecurityContextService);
        this.toastrService = ServiceProvider.get(OntoToastrService);
        this.namespacesService = ServiceProvider.get(NamespacesService);
        this.namespaceContextService = ServiceProvider.get(NamespacesContextService);
        this.languageService = ServiceProvider.get(LanguageService);
        this.authService = ServiceProvider.get(AuthenticationService);
        this.authorizationService = ServiceProvider.get(AuthorizationService);
        this.eventService = ServiceProvider.get(EventService);
        this.configurationContextService = ServiceProvider.get(ConfigurationContextService);
        this.runtimeConfigurationContextService = ServiceProvider.get(RuntimeConfigurationContextService);
        this.logger = LoggerProvider.logger;
        /** Whether the search component should appear */
        this.shouldShowSearch = true;
        this.isHomePage = isHomePage();
        this.showUserMenu = false;
        this.showLoginButton = false;
        // ========================
        // Private
        // ========================
        this.isActiveLocationLoading = false;
        this.repositoryItems = [];
        /** Array of subscription cleanup functions */
        this.subscriptions = new SubscriptionList();
        this.skipUpdateActiveOperationsTimes = 0;
        this.labels = {
            [labelKeys$1.LOGO_LINK]: TranslationService.translate(labelKeys$1.LOGO_LINK)
        };
        this.getRepositoryPermission = (repo) => {
            return this.authorizationService.getRepositoryPermission(repo);
        };
        this.repositorySizeInfoFetcher = (repo) => {
            return this.repositoryService.getRepositorySizeInfo(repo);
        };
        this.showViewResourceMessage = (event) => {
            event.stopPropagation();
            this.toastrService.info(TranslationService.translate('rdf_search.toasts.use_view_resource'));
            this.shouldShowSearch = false;
            HtmlUtil.focusElement('#search-resource-input-home input');
            this.eventService.emit({ NAME: ResourceSearchConstants.RDF_SEARCH_ICON_CLICKED });
        };
    }
    // ========================
    // Lifecycle methods
    // ========================
    disconnectedCallback() {
        this.subscriptions.unsubscribeAll();
        this.stopOperationPolling();
    }
    connectedCallback() {
        this.currentRepository = this.repositoryContextService.getSelectedRepository();
        this.setupTotalRepositoryFormater();
        this.setupExpansionRatioFormater();
        this.subscribeToEvents();
        this.currentRoute = getCurrentRoute();
        this.startOperationPolling();
        this.onTranslate(labelKeys$1.LOGO_LINK);
    }
    render() {
        var _a, _b;
        return (h(Host, { key: 'f9e7c6d119bae9020228b5cea360dcf7b6116db6' }, h("div", { key: '03f7163a7c5de73ba1de4509bf1ea4eb2a6c8552', class: "header-component" }, h("div", { key: '3a7f1a6097f8851da82e8bf590fd7b885cf0ef35', class: "left-section brand" }, h("a", { key: '5c6918744f5ef86076a60ca31d3e51bc8e45b575', class: "home-page", onClick: navigateTo('./') }, h("img", { key: 'a005c54ec34049d90ea59c634da6fd65b19b55d2', src: this.applicationLogoPath, class: "big-logo", alt: this.labels[labelKeys$1.LOGO_LINK] }))), h("div", { key: '772dfd71575393cdafa7e9d9d01a490c50009843', class: "right-section" }, h("onto-search-icon", { key: 'b8ff8ac680d242e0e31b7a232c278b234e34be97', class: "rdf-search-button", onClick: this.showViewResourceMessage, "data-test": "onto-show-view-resource-message", style: { display: this.shouldShowSearch && this.isHomePage ? 'block' : 'none' } }), h("onto-rdf-search", { key: 'cf8775a3b783dbd1a643141006c1e3ce055a0127', "data-test": "onto-open-rdf-search-button", style: { display: this.shouldShowSearch && !this.isHomePage ? 'block' : 'none' } }), ((_a = this.activeOperations) === null || _a === void 0 ? void 0 : _a.allRunningOperations.getItems().length)
            ? h("onto-operations-notification", { activeOperations: this.activeOperations })
            : '', this.license && !((_b = this.license) === null || _b === void 0 ? void 0 : _b.valid) ?
            h("onto-license-alert", { license: this.license }) : '', h("onto-repository-selector", { key: 'e5a5e41e3efbc067e5661b539a264ae1c03b54cd', currentRepository: this.currentRepository, items: this.repositoryItems, repositorySizeInfoFetcher: this.repositorySizeInfoFetcher, totalTripletsFormatter: this.totalTripletsFormatter, expansionRatioFormatter: this.expansionRatioFormatter, getRepositoryPermission: this.getRepositoryPermission }), h("onto-language-selector", { key: 'f5ba7d9c8eb347dff2f2dcae54e54bd453ac4d2c', "dropdown-alignment": "right" }), this.showUserMenu && this.user ?
            h("onto-user-menu", { user: this.user, securityConfig: this.securityConfig }) : '', this.showLoginButton ? h("onto-user-login", null) : ''))));
    }
    // ========================
    // Subscriptions
    // ========================
    subscribeToEvents() {
        this.subscribeToSecurityContextChange();
        this.subscribeToRepositoryListChanged();
        this.subscribeToLicenseChange();
        this.subscribeToRepositoryChange();
        this.subscribeToActiveRepositoryLocationChange();
        this.subscribeToActiveRepoLoadingChange();
        this.subscribeToNavigationEnd();
        this.subscribeToLanguageChanged();
        this.subscribeToAuthenticatedUserChange();
        this.subscribeToThemeModeChange();
    }
    subscribeToThemeModeChange() {
        this.subscriptions.add(this.runtimeConfigurationContextService.onThemeModeChanged((themeMode) => {
            this.applicationLogoPath = this.configurationContextService.getApplicationLogoPath(themeMode);
        }));
    }
    subscribeToRepositoryListChanged() {
        return this.repositoryContextService.onRepositoryListChanged((repositories) => {
            if (!(repositories === null || repositories === void 0 ? void 0 : repositories.getItems().length)) {
                this.resetOnMissingRepositories();
            }
            else {
                this.initOnRepositoryListChanged(repositories);
            }
        });
    }
    subscribeToLicenseChange() {
        this.subscriptions.add(ServiceProvider.get(LicenseContextService)
            .onLicenseChanged((license) => {
            this.license = license;
        }));
    }
    subscribeToRepositoryChange() {
        this.subscriptions.add(this.repositoryContextService.onSelectedRepositoryChanged((repositoryReference) => {
            // The observer can receive a reference (having id and location), so we need to find the full repository object.
            this.currentRepository = this.repositoryContextService.findRepository(repositoryReference);
            this.shouldShowSearch = this.shouldShowRdfSearch();
            this.loadNamespaces();
            this.updateRepositoryItems();
        }));
    }
    subscribeToSecurityContextChange() {
        this.subscriptions.add(this.securityContextService.onSecurityConfigChanged((config) => {
            this.securityConfig = config;
            setTimeout(() => {
                this.updateVisibility();
            });
        }));
    }
    subscribeToAuthenticatedUserChange() {
        this.subscriptions.add(this.securityContextService.onAuthenticatedUserChanged((user) => {
            this.user = user;
            this.updateRepositoryItems();
            this.updateVisibility();
        }));
    }
    subscribeToActiveRepositoryLocationChange() {
        this.subscriptions.add(this.repositoryLocationContextService.onActiveLocationChanged(() => {
            this.shouldShowSearch = this.shouldShowRdfSearch();
        }));
    }
    subscribeToActiveRepoLoadingChange() {
        this.subscriptions.add(this.repositoryLocationContextService.onIsLoadingChanged((isLoading) => {
            this.isActiveLocationLoading = isLoading;
            this.shouldShowSearch = this.shouldShowRdfSearch();
        }));
    }
    subscribeToNavigationEnd() {
        this.subscriptions.add(this.eventService.subscribe(EventName.NAVIGATION_END, () => {
            this.shouldShowSearch = this.shouldShowRdfSearch();
            this.isHomePage = isHomePage();
            this.currentRoute = getCurrentRoute();
            this.updateVisibility();
        }));
    }
    subscribeToLanguageChanged() {
        this.subscriptions.add(ServiceProvider.get(LanguageContextService)
            .onSelectedLanguageChanged((language) => {
            this.setupTotalRepositoryFormater(language);
            this.setupExpansionRatioFormater(language);
        }));
    }
    onTranslate(key) {
        this.subscriptions.add(TranslationService.onTranslate(key, [], (translation) => {
            this.labels[key] = translation;
        }));
    }
    // ========================
    // Repository Logic
    // ========================
    resetOnMissingRepositories() {
        this.repositoryItems = [];
        this.repositoryList = new RepositoryList();
        this.currentRepository = undefined;
    }
    initOnRepositoryListChanged(repositories) {
        this.repositoryList = repositories;
        this.updateRepositoryItems();
    }
    updateRepositoryItems() {
        this.repositoryItems = this.getRepositoriesDropdownItems();
    }
    getRepositoriesDropdownItems() {
        var _a;
        if (!((_a = this.repositoryList) === null || _a === void 0 ? void 0 : _a.getItems().length)) {
            return [];
        }
        this.repositoryList.sortByLocationAndId();
        let repositories;
        if (this.currentRepository) {
            repositories = this.repositoryList.filterByRepository([this.currentRepository]);
        }
        else {
            repositories = this.repositoryList.getItems();
        }
        return repositories
            .filter((repository) => this.authorizationService.canReadRepo(repository) || this.authorizationService.canReadGqlRepo(repository))
            .map((repository) => {
            return new DropdownItem()
                .setName(h(SelectorItemButton, { repository: repository }))
                .setValue(repository)
                .setGuideSelector(`repository-id-${repository.id}`);
        });
    }
    loadNamespaces() {
        if (!this.currentRepository || !this.authorizationService.canReadRepo(this.currentRepository)) {
            return;
        }
        // TODO: check why loaction not used maybe it is added in autorization interceptor
        this.namespacesService.getNamespaces(this.currentRepository.id)
            .then((namespaces) => this.namespaceContextService.updateNamespaces(namespaces));
    }
    updateVisibility() {
        var _a, _b, _c;
        const isSecurityEnabled = (_a = this.securityConfig) === null || _a === void 0 ? void 0 : _a.enabled;
        const isLoggedIn = this.authService.isLoggedIn();
        let isAuthenticated = false;
        try {
            isAuthenticated = this.authService.isAuthenticated();
        }
        catch (_d) {
            isAuthenticated = false;
        }
        const isFreeAccessEnabled = (_c = (_b = this.securityConfig) === null || _b === void 0 ? void 0 : _b.freeAccess) === null || _c === void 0 ? void 0 : _c.enabled;
        this.showLoginButton = isSecurityEnabled && isFreeAccessEnabled && !isLoggedIn && this.currentRoute !== 'login';
        this.showUserMenu = isSecurityEnabled && isAuthenticated && isLoggedIn;
        this.shouldShowSearch = this.shouldShowRdfSearch();
    }
    // ========================
    // Monitoring and pooling
    // ========================
    startOperationPolling() {
        clearInterval(this.pollingInterval);
        this.pollingInterval = WindowService.getWindow().setInterval(() => {
            if (!this.authService.isAuthenticated()) {
                this.activeOperations = undefined;
                return;
            }
            if (this.skipUpdateActiveOperationsTimes > 0) {
                // Requested to skip this run, the number of skips is a Fibonacci sequence when errors are consecutive.
                this.skipUpdateActiveOperationsTimes--;
                return;
            }
            if (!this.currentRepository) {
                return;
            }
            this.monitoringService
                .getOperations(this.currentRepository.id)
                .then((operations) => {
                if (!ObjectUtil.deepEqual(this.activeOperations, operations)) {
                    this.activeOperations = operations;
                }
                this.fibonacciGenerator.reset();
                this.skipUpdateActiveOperationsTimes = 0;
            })
                .catch((error) => {
                this.logger.error('Error fetching active operations', error);
                this.activeOperations = undefined;
                this.skipUpdateActiveOperationsTimes = this.fibonacciGenerator.next();
            });
        }, this.UPDATE_ACTIVE_OPERATION_TIME_INTERVAL);
    }
    stopOperationPolling() {
        clearInterval(this.pollingInterval);
        this.activeOperations = undefined;
    }
    // ========================
    // Render logic
    // ========================
    shouldShowRdfSearch() {
        return !!this.currentRepository &&
            (!this.isActiveLocationLoading || getPathName() === '/repository') &&
            this.authorizationService.canReadRepo(this.currentRepository);
    }
    // ========================
    // Language, formatting
    // ========================
    setupTotalRepositoryFormater(language) {
        if (!language) {
            language = this.languageService.getDefaultLanguage();
        }
        this.totalTripletsFormatter = new Intl.NumberFormat(language, {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
    }
    setupExpansionRatioFormater(language) {
        if (!language) {
            language = this.languageService.getDefaultLanguage();
        }
        this.expansionRatioFormatter = new Intl.NumberFormat(language, {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
};
OntoHeader.style = ontoHeaderCss;

const ontoLoaderSvg = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZGR0Ij4KPHN2ZwogICAgICAgIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIKICAgICAgICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICAgICAgIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyIKICAgICAgICB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogICAgICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgICAgICB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIKICAgICAgICB4bWxuczpzb2RpcG9kaT0iaHR0cDovL3NvZGlwb2RpLnNvdXJjZWZvcmdlLm5ldC9EVEQvc29kaXBvZGktMC5kdGQiCiAgICAgICAgeG1sbnM6aW5rc2NhcGU9Imh0dHA6Ly93d3cuaW5rc2NhcGUub3JnL25hbWVzcGFjZXMvaW5rc2NhcGUiCiAgICAgICAgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pbllNaW4iCiAgICAgICAgdmlld0JveD0iMCAwIDUwIDUwIgogICAgICAgIGlkPSJzdmcyIgogICAgICAgIHZlcnNpb249IjEuMSIKICAgICAgICBpbmtzY2FwZTp2ZXJzaW9uPSIwLjQ4LjAgcjk2NTQiCiAgICAgICAgc29kaXBvZGk6ZG9jbmFtZT0ibmFtZXN2Zy5zdmciPgogICAgPGNpcmNsZSBjeD0iMjEuNSIgY3k9IjcuNSIgcj0iMS41IiBmaWxsPSIjZmYzOTAwIj4KICAgICAgICA8YW5pbWF0ZSByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgZHVyPSIycyIgYmVnaW49IjBzIgogICAgICAgICAgICAgICAgIHZhbHVlcz0iMS41OyAzOyAxLjU7IDEuNTsgMS41OyAxLjU7IDEuNTsgMS41OyAxLjU7IDEuNTsgMS41OyAxLjU7IDEuNSIgYXR0cmlidXRlVHlwZT0iWE1MIgogICAgICAgICAgICAgICAgIGF0dHJpYnV0ZU5hbWU9InIiLz4KICAgIDwvY2lyY2xlPgogICAgPGNpcmNsZSBjeD0iMzEiIGN5PSIxMCIgcj0iNCIgZmlsbD0iI2ZmMzkwMCI+CiAgICAgICAgPGFuaW1hdGUgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGR1cj0iMnMiIGJlZ2luPSIwLjE1cyIgdmFsdWVzPSI0OyA4OyA0OyA0OyA0OyA0OyA0OyA0OyA0OyA0OyA0OyA0OyA0IgogICAgICAgICAgICAgICAgIGF0dHJpYnV0ZVR5cGU9IlhNTCIgYXR0cmlidXRlTmFtZT0iciIvPgogICAgPC9jaXJjbGU+CiAgICA8Y2lyY2xlIGN4PSIzNyIgY3k9IjE1IiByPSIyIiBmaWxsPSIjZmYzOTAwIj4KICAgICAgICA8YW5pbWF0ZSByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgZHVyPSIycyIgYmVnaW49IjAuM3MiIHZhbHVlcz0iMjsgNDsgMjsgMjsgMjsgMjsgMjsgMjsgMjsgMjsgMjsgMjsgMiIKICAgICAgICAgICAgICAgICBhdHRyaWJ1dGVUeXBlPSJYTUwiIGF0dHJpYnV0ZU5hbWU9InIiLz4KICAgIDwvY2lyY2xlPgogICAgPGNpcmNsZSBjeD0iNDAuNSIgY3k9IjIzLjUiIHI9IjQuNSIgZmlsbD0iI2ZmMzkwMCI+CiAgICAgICAgPGFuaW1hdGUgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGR1cj0iMnMiIGJlZ2luPSIwLjQ1cyIKICAgICAgICAgICAgICAgICB2YWx1ZXM9IjQuNTsgOTsgNC41OyA0LjU7IDQuNTsgNC41OyA0LjU7IDQuNTsgNC41OyA0LjU7IDQuNTsgNC41OyA0LjUiIGF0dHJpYnV0ZVR5cGU9IlhNTCIKICAgICAgICAgICAgICAgICBhdHRyaWJ1dGVOYW1lPSJyIi8+CiAgICA8L2NpcmNsZT4KICAgIDxjaXJjbGUgY3g9IjM5IiBjeT0iMzMiIHI9IjMiIGZpbGw9IiNmZjM5MDAiPgogICAgICAgIDxhbmltYXRlIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiBkdXI9IjJzIiBiZWdpbj0iMC42cyIgdmFsdWVzPSIzOyA2OyAzOyAzOyAzOyAzOyAzOyAzOyAzOyAzOyAzOyAzOyAzIgogICAgICAgICAgICAgICAgIGF0dHJpYnV0ZVR5cGU9IlhNTCIgYXR0cmlidXRlTmFtZT0iciIvPgogICAgPC9jaXJjbGU+CiAgICA8Y2lyY2xlIGN4PSIzNC41IiBjeT0iMzguNSIgcj0iMS41IiBmaWxsPSIjZmYzOTAwIj4KICAgICAgICA8YW5pbWF0ZSByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgZHVyPSIycyIgYmVnaW49IjAuNzVzIgogICAgICAgICAgICAgICAgIHZhbHVlcz0iMS41OyAzOyAxLjU7IDEuNTsgMS41OyAxLjU7IDEuNTsgMS41OyAxLjU7IDEuNTsgMS41OyAxLjU7IDEuNSIgYXR0cmlidXRlVHlwZT0iWE1MIgogICAgICAgICAgICAgICAgIGF0dHJpYnV0ZU5hbWU9InIiLz4KICAgIDwvY2lyY2xlPgogICAgPGNpcmNsZSBjeD0iMjkiIGN5PSI0MiIgcj0iMiIgZmlsbD0iI2ZmMzkwMCI+CiAgICAgICAgPGFuaW1hdGUgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGR1cj0iMnMiIGJlZ2luPSIwLjlzIiB2YWx1ZXM9IjI7IDQ7IDI7IDI7IDI7IDI7IDI7IDI7IDI7IDI7IDI7IDI7IDIiCiAgICAgICAgICAgICAgICAgYXR0cmlidXRlVHlwZT0iWE1MIiBhdHRyaWJ1dGVOYW1lPSJyIi8+CiAgICA8L2NpcmNsZT4KICAgIDxjaXJjbGUgY3g9IjIxLjUiIGN5PSI0Mi41IiByPSIyLjUiIGZpbGw9IiNmZjM5MDAiPgogICAgICAgIDxhbmltYXRlIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiBkdXI9IjJzIiBiZWdpbj0iMS4wNXMiCiAgICAgICAgICAgICAgICAgdmFsdWVzPSIyLjU7IDU7IDIuNTsgMi41OyAyLjU7IDIuNTsgMi41OyAyLjU7IDIuNTsgMi41OyAyLjU7IDIuNTsgMi41IiBhdHRyaWJ1dGVUeXBlPSJYTUwiCiAgICAgICAgICAgICAgICAgYXR0cmlidXRlTmFtZT0iciIvPgogICAgPC9jaXJjbGU+CiAgICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjM5IiByPSI0IiBmaWxsPSIjZmYzOTAwIj4KICAgICAgICA8YW5pbWF0ZSByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgZHVyPSIycyIgYmVnaW49IjEuMnMiIHZhbHVlcz0iNDsgODsgNDsgNDsgNDsgNDsgNDsgNDsgNDsgNDsgNDsgNDsgNCIKICAgICAgICAgICAgICAgICBhdHRyaWJ1dGVUeXBlPSJYTUwiIGF0dHJpYnV0ZU5hbWU9InIiLz4KICAgIDwvY2lyY2xlPgogICAgPGNpcmNsZSBjeD0iNyIgY3k9IjMyIiByPSIyIiBmaWxsPSIjZmYzOTAwIj4KICAgICAgICA8YW5pbWF0ZSByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgZHVyPSIycyIgYmVnaW49IjEuMzVzIiB2YWx1ZXM9IjI7IDQ7IDI7IDI7IDI7IDI7IDI7IDI7IDI7IDI7IDI7IDI7IDIiCiAgICAgICAgICAgICAgICAgYXR0cmlidXRlVHlwZT0iWE1MIiBhdHRyaWJ1dGVOYW1lPSJyIi8+CiAgICA8L2NpcmNsZT4KICAgIDxjaXJjbGUgY3g9IjUuNSIgY3k9IjI1LjUiIHI9IjIuNSIgZmlsbD0iI2ZmMzkwMCI+CiAgICAgICAgPGFuaW1hdGUgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGR1cj0iMnMiIGJlZ2luPSIxLjVzIgogICAgICAgICAgICAgICAgIHZhbHVlcz0iMi41OyA1OyAyLjU7IDIuNTsgMi41OyAyLjU7IDIuNTsgMi41OyAyLjU7IDIuNTsgMi41OyAyLjU7IDIuNSIgYXR0cmlidXRlVHlwZT0iWE1MIgogICAgICAgICAgICAgICAgIGF0dHJpYnV0ZU5hbWU9InIiLz4KICAgIDwvY2lyY2xlPgogICAgPGNpcmNsZSBjeD0iOCIgY3k9IjE2IiByPSI0IiBmaWxsPSIjZmYzOTAwIj4KICAgICAgICA8YW5pbWF0ZSByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgZHVyPSIycyIgYmVnaW49IjEuNjVzIiB2YWx1ZXM9IjQ7IDg7IDQ7IDQ7IDQ7IDQ7IDQ7IDQ7IDQ7IDQ7IDQ7IDQ7IDQiCiAgICAgICAgICAgICAgICAgYXR0cmlidXRlVHlwZT0iWE1MIiBhdHRyaWJ1dGVOYW1lPSJyIi8+CiAgICA8L2NpcmNsZT4KICAgIDxjaXJjbGUgY3g9IjE0IiBjeT0iMTAiIHI9IjMiIGZpbGw9IiNmZjM5MDAiPgogICAgICAgIDxhbmltYXRlIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiBkdXI9IjJzIiBiZWdpbj0iMS44cyIgdmFsdWVzPSIzOyA2OyAzOyAzOyAzOyAzOyAzOyAzOyAzOyAzOyAzOyAzOyAzIgogICAgICAgICAgICAgICAgIGF0dHJpYnV0ZVR5cGU9IlhNTCIgYXR0cmlidXRlTmFtZT0iciIvPgogICAgPC9jaXJjbGU+Cjwvc3ZnPgo=';

const ontoLoaderCss = ":host(.onto-loader-attached){position:fixed;top:0;left:0;width:100%;height:100%;display:none;align-items:center;justify-content:center}:host{display:none}:host .onto-loader{white-space:nowrap;width:fit-content}:host .onto-loader .loader-spinner{margin-left:auto;margin-right:auto}:host .onto-loader .loader-spinner circle{fill:var(--gw-loader-color)}:host .onto-loader .loader-message{text-align:center}:host(.onto-loader-active){display:flex;visibility:visible !important}";

const OntoLoader = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        /**
         * Size of the loader in pixels (width and height).
         */
        this.size = 100;
        /**
         * Whether the loader is currently active and should be displayed.
         */
        this.loading = false;
        /**
         * Optional message text to display below the loader.
         */
        this.messageText = '';
        /**
         * CSS selector of a DOM element to attach the loader to as a centered overlay.
         */
        this.targetSelector = '';
        this.ATTACHED_CLASS = 'onto-loader-attached';
        this.rawSvg = atob(ontoLoaderSvg.split(',')[1]);
        this.logger = LoggerProvider.logger;
    }
    componentDidLoad() {
        this.attachToSelector();
    }
    render() {
        return (h(Host, { key: '688a22508c74f7d72f4122ad6b7d34dd4be6ce4e', class: { [this.ATTACHED_CLASS]: !!this.targetSelector, 'onto-loader-active': this.loading } }, h("div", { key: '46ec9a8f161dd62c22bab137086ebb3943a2aea7', class: "onto-loader", "guide-selector": "onto-loader" }, h("div", { key: '3eea0d3e2be7b587ca149753f0d5b7fccb6a15ac', class: "loader-spinner", style: { 'width': this.size + 'px', 'height': this.size + 'px' }, innerHTML: this.rawSvg }), this.messageText && h("div", { key: '0c93bfbbf12a57434ff22cc01d69e55e24fd8914', class: "loader-message", style: { 'font-size': (this.size / 4) + 'px' } }, this.messageText))));
    }
    attachToSelector() {
        if (!this.targetSelector) {
            return;
        }
        const target = document.querySelector(this.targetSelector);
        if (!target) {
            this.logger.warn('You tried to attach the loader to an element that does not exist: ', this.targetSelector);
            this.loader.classList.remove(this.ATTACHED_CLASS);
            return;
        }
        target.appendChild(this.loader);
    }
    get loader() { return getElement(this); }
};
OntoLoader.style = ontoLoaderCss;

/**
 * Event fired when the navbar is toggled by the user.
 */
class NavbarToggledEvent {
    /**
     * Constructs the event.
     * @param isOpened - Whether the navbar is opened.
     */
    constructor(isOpened) {
        this.type = 'navbarToggled';
        this.payload = isOpened;
    }
}

/**
 * The UI model for the navbar component.
 */
class NavbarModel {
    /**
     * Creates a new instance of the navbar model.
     * @param items The model items. If no items are provided, the model will be empty by default.
     */
    constructor(items = []) {
        this._items = items;
    }
    hasParent(parentLabel) {
        return this._items.some((parentItem) => parentLabel === parentItem.label);
    }
    /**
     * Clones the model. This method is useful when the model needs to be modified without affecting the original model.
     * @return The cloned model.
     */
    getModel() {
        const cloneItem = (item) => {
            const clonedChildren = item.children.map(cloneItem);
            return new NavbarItemModel(Object.assign(Object.assign({}, item), { children: clonedChildren }));
        };
        return this._items.map(cloneItem);
    }
    /**
     * Adds a new top level item to the model. The sub menu items should be added separately as children before calling
     * this method.
     * @param item The item to be added.
     */
    addItem(item) {
        this._items.push(item);
    }
    /**
     * Returns the selected root item.
     * @return The selected root item or null if no item is selected.
     */
    getSelectedRootItem() {
        return this._items.find((item) => item.selected);
    }
    /**
     * Checks if the parent of the provided item is opened.
     * @param item The menu item for which the parent needs to be checked.
     * @return True if the parent is opened, false otherwise. If the item has no parent, the method returns false.
     */
    isParentOpened(item) {
        var _a;
        return !!((_a = this.getParentItem(item)) === null || _a === void 0 ? void 0 : _a.open);
    }
    /**
     * Returns the top level menu item with the given label.
     * @param parent The label of the top level menu item. Each menu item has a label which identifies it in the model.
     * The label comes from the main menu plugin definition and should be unique for each menu item.
     * @return The top level menu item or undefined if no item is found.
     */
    getTopLevelItem(parent) {
        return this._items.find((item) => item.label === parent);
    }
    /**
     * Returns the top level menu item with the same label as the parent property of the provided item.
     * @param item The menu item for which the parent is needed.
     * @return The parent menu item or undefined if no parent is found.
     */
    getParentItem(item) {
        return this._items.find((i) => i.label === item.parent);
    }
    /**
     * Deselects all menu items.
     */
    deselectAll() {
        this.walk((item) => {
            item.selected = false;
        });
    }
    /**
     * Closes all opened top level menu items.
     */
    closeAll() {
        this.walk((item) => {
            this.setOpen(item, false);
        });
    }
    /**
     * Deselects a top level menu item. When a menu item is selected it is highlighted in the UI.
     * @param item The top level menu item to be deselected.
     */
    deselectItem(item) {
        item.selected = false;
    }
    /**
     * Selects a top level menu item. When a menu item is selected it is highlighted in the UI.
     * @param item The top level menu item to be selected.
     */
    selectItem(item) {
        if (item.label) {
            item.selected = true;
        }
        else {
            this.selectItem(item.parentModel);
        }
    }
    /**
     * Checks if a top level menu item has a selected submenu.
     * @param item The top level menu item to be checked.
     * @return True if the top level menu item has a selected submenu, false otherwise.
     */
    hasSelectedSubmenu(item) {
        if (!item.children) {
            return false;
        }
        return item.children.some(child => this.hasSelection(child));
    }
    /**
     * Recursively checks if any submenu (child or nested) is selected.
     * @param {NavbarItemModel} item - The submenu item to check.
     * @return {boolean} True if selected, or if any descendant is selected.
     */
    hasSelection(item) {
        if (item.selected) {
            return true;
        }
        if (item.children) {
            return item.children.some(child => this.hasSelection(child));
        }
        return false;
    }
    /**
     * Marks an opened top level menu item as closed. If the item has a selected submenu, then the top level menu item
     * is marked as selected to indicate that the submenu is active.
     */
    closeOpened() {
        const opened = this._items.find((item) => item.open);
        if (opened) {
            if (this.hasSelectedSubmenu(opened)) {
                this.selectItem(opened);
            }
            this.setOpen(opened, false);
        }
    }
    /**
     * Opens a top level menu item and closes all other top level menu items.
     * @param item The top level menu item to be opened.
     */
    open(item) {
        this.walk((item) => {
            this.setOpen(item, false);
        });
        this.openItemAndParent(item);
    }
    openItemAndParent(item) {
        if (item.parentModel) {
            this.openItemAndParent(item.parentModel);
        }
        this.setOpen(item, true);
    }
    /**
     * Closes all top level menu items except the one that is the parent of the current item.
     * @param currentItem The current menu item.
     */
    closeOtherParents(currentItem) {
        const parent = currentItem.parent;
        this.walk((item) => {
            if (item.label !== parent) {
                this.setOpen(item, false);
            }
        });
    }
    /**
     * Sets the open state of a menu item.
     * @param item The menu item to be updated.
     * @param open The open state to be set.
     */
    setOpen(item, open) {
        item.open = open;
    }
    /**
     * Highlights the selected menu item by selecting its parent if it has one.
     * This is useful when the navbar is collapsed. This operation is the opposite of the unhighlightSelected method.
     */
    highlightSelected() {
        const selectedItem = this.getSelectedItem();
        if (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.hasParent) {
            this.selectItem(this.getParentItem(selectedItem));
        }
    }
    /**
     * Unhighlights the selected opened menu item if it has a submenu. This is useful when the navbar is going to be expanded.
     * This operation is the opposite of the highlightSelected method.
     */
    unhighlightSelected() {
        const selectedRootItem = this.getSelectedRootItem();
        if (selectedRootItem && selectedRootItem.children.length && selectedRootItem.open) {
            this.deselectItem(selectedRootItem);
        }
    }
    /**
     * Finds out the selected menu item. It can be a top level menu item or a submenu item.
     * @return The selected menu item or null if no item is selected.
     */
    getSelectedItem() {
        let selectedItem = null;
        const findSelected = (item) => {
            if (item.selected) {
                selectedItem = item;
                return true;
            }
            if (item.children) {
                for (const child of item.children) {
                    if (findSelected(child)) {
                        return true;
                    }
                }
            }
            return false;
        };
        this._items.some(findSelected);
        return selectedItem;
    }
    expandSelected() {
        const selectedItem = this.getSelectedItem();
        if (selectedItem) {
            if (selectedItem.hasParent) {
                this.open(this.getParentItem(selectedItem));
            }
            else {
                this.open(selectedItem);
            }
        }
    }
    /**
     * Finds out the menu item by its href property and marks it as selected if it is a top level menu. If the menu item
     * is a sub menu, it marks its parent as opened and the sub menu item as selected.
     * @param selectedMenu The href of the menu item to be selected.
     */
    initSelected(selectedMenu) {
        this.walk((item) => {
            var _a;
            let path = selectedMenu;
            if ((_a = item.href) === null || _a === void 0 ? void 0 : _a.includes('*')) {
                path = this.getWildcardPath(selectedMenu, item.href);
            }
            // Remove query parameters from href before comparison because we have added them dynamically earlier.
            const separatorIndex = item.href.search(/[?]/);
            // If no separator is found, use the full length of the href.
            const cleanHref = separatorIndex === -1 ? item.href : item.href.substring(0, separatorIndex);
            if (path === cleanHref) {
                if (item.hasParent) {
                    this.open(item);
                }
                this.selectItem(item);
            }
        });
    }
    /**
     * Compares a given path against a href pattern that may contain wildcards.
     * This function is used to match menu item hrefs that include wildcard segments.
     *
     * @param path - The actual path to compare against the href pattern.
     * @param href - The href pattern that may contain wildcards ('*').
     * @returns A string representing the matched path. If the path matches the href pattern,
     *          it returns a version of the href where wildcards are preserved. If there's no match,
     *          it returns the original path unchanged.
     */
    getWildcardPath(path, href) {
        const pathParts = path.split('/');
        const hrefParts = href.split('/');
        if (pathParts.length !== hrefParts.length) {
            return path; // Path and href have different number of segments, no match
        }
        const resultParts = [];
        for (let i = 0; i < hrefParts.length; i++) {
            if (hrefParts[i] === '*') {
                resultParts.push('*');
            }
            else if (hrefParts[i] !== pathParts[i]) {
                return path; // Mismatch in non-wildcard segment
            }
            else {
                resultParts.push(hrefParts[i]);
            }
        }
        return resultParts.join('/');
    }
    /**
     * Sorts the menu items by their order property.
     * @return {this} The sorted model.
     */
    sorted() {
        this._items
            .filter((item) => item.children)
            .forEach((item) => {
            item.children.sort(NavbarModel.compare);
        });
        this._items.sort(NavbarModel.compare);
        return this;
    }
    static compare(a, b) {
        return a.order - b.order;
    }
    /**
     * Walks recursively through the model and executes the provided callback for each item.
     * @param callback The callback to be executed for each item.
     */
    walk(callback) {
        this.walkRecursively(this.items, callback);
    }
    /**
     * Recursively walks through a list of navbar items and applies the callback.
     * @param items The items to walk through.
     * @param callback The callback to execute on each item.
     */
    walkRecursively(items, callback) {
        items.forEach((item) => {
            var _a;
            callback(item);
            if ((_a = item.children) === null || _a === void 0 ? void 0 : _a.length) {
                this.walkRecursively(item.children, callback);
            }
        });
    }
    get items() {
        return this._items;
    }
}
/**
 * The model for a single menu item.
 */
class NavbarItemModel {
    constructor(data) {
        var _a;
        this._selected = false;
        this._open = false;
        this._order = data.order;
        this._label = data.label;
        this._labelKey = data.labelKey;
        this._href = data.href;
        this._children = [...(_a = data.children) !== null && _a !== void 0 ? _a : []];
        this._hasParent = data.hasParent;
        this._parent = data.parent;
        this._selected = data.selected;
        this._open = data.open;
        this._documentationHref = data.documentationHref;
        this._hrefFun = data.hrefFun;
        this._editions = data.editions;
        this._icon = data.icon;
        this._role = data.role;
        this._guideSelector = data.guideSelector;
        this._testSelector = data.testSelector;
        this._shouldShow = data.shouldShow;
        this._parentModel = data.parentModel;
    }
    addChild(child) {
        this.children.push(child);
        child.setParent(this);
    }
    addChildren(...children) {
        children.forEach((child) => {
            this.addChild(child);
        });
    }
    /**
     * Determines whether the current menu item has submenus.
     * In this context, items with a href value of '#' are treated as parent items
     * and are expected to have submenus. This behavior is due to the fact that
     * all top-level items are registered with href set to '#' when added to the PluginRegistry.
     *
     * @returns {boolean} True if the item is a parent (has submenus), otherwise false.
     */
    hasSubmenus() {
        return this._href === '#';
    }
    get parent() {
        return this._parent;
    }
    set parent(value) {
        this._parent = value;
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
    }
    get label() {
        return this._label;
    }
    set label(value) {
        this._label = value;
    }
    get labelKey() {
        return this._labelKey;
    }
    set labelKey(value) {
        this._labelKey = value;
    }
    get documentationHref() {
        return this._documentationHref;
    }
    set documentationHref(value) {
        this._documentationHref = value;
    }
    get href() {
        return this._href;
    }
    set href(value) {
        this._href = value;
    }
    get children() {
        return this._children;
    }
    set children(value) {
        this._children = value;
    }
    get hasParent() {
        return this._hasParent;
    }
    set hasParent(value) {
        this._hasParent = value;
    }
    get selected() {
        return this._selected;
    }
    set selected(value) {
        this._selected = value;
    }
    get open() {
        return this._open;
    }
    set open(value) {
        this._open = value;
    }
    get hrefFun() {
        return this._hrefFun;
    }
    set hrefFun(value) {
        this._hrefFun = value;
    }
    get editions() {
        return this._editions;
    }
    set editions(value) {
        this._editions = value;
    }
    get icon() {
        return this._icon;
    }
    set icon(value) {
        this._icon = value;
    }
    get role() {
        return this._role;
    }
    set role(value) {
        this._role = value;
    }
    get guideSelector() {
        return this._guideSelector;
    }
    set guideSelector(value) {
        this._guideSelector = value;
    }
    get testSelector() {
        return this._testSelector;
    }
    set testSelector(value) {
        this._testSelector = value;
    }
    get parentModel() {
        return this._parentModel;
    }
    set parentModel(value) {
        this._parentModel = value;
    }
    get shouldShow() {
        return this._shouldShow;
    }
    set shouldShow(value) {
        this._shouldShow = value;
    }
    setParent(parent) {
        this.parentModel = parent;
        this.hasParent = !!parent;
    }
}

const logger = LoggerProvider.logger;
class NavbarService {
    /**
     * Maps external menu plugins to navbar model.
     * @param navbarPlugins Plugin definitions for the main menu.
     * @param productInfo The product info.
     * @param currentRepositoryId The current repository id.
     * @param repositoryIdParamName The name of the repository id query parameter.
     * @returns The navbar model.
     */
    static map(navbarPlugins, productInfo, currentRepositoryId, repositoryIdParamName) {
        const navbarModel = new NavbarModel();
        NavbarService.setTopLevelMenuItems(navbarPlugins, navbarModel, productInfo);
        NavbarService.setSubmenuItems(navbarPlugins, navbarModel, productInfo);
        if (currentRepositoryId) {
            NavbarService.addRepositoryIdToHrefAttributes(navbarModel, currentRepositoryId, repositoryIdParamName);
        }
        return navbarModel.sorted();
    }
    static addRepositoryIdToHrefAttributes(navbarModel, currentRepositoryId, repositoryIdParamName) {
        navbarModel.items.forEach((item) => {
            const hasChildren = item.children && item.children.length > 0;
            if (!hasChildren) {
                item.href = `${item.href}?${repositoryIdParamName}=${currentRepositoryId}`;
            }
            else {
                item.children
                    // External links don't need repositoryId param
                    .filter((childItem) => !childItem.documentationHref)
                    .forEach((childItem) => {
                    childItem.href = `${childItem.href}?${repositoryIdParamName}=${currentRepositoryId}`;
                });
            }
        });
    }
    /**
     * Adds the current repositoryId as a query parameter to href attribute of each menu item which does not have children
     * or documentationHref (external link).
     * @param navbarModel The navbar model.
     * @param currentRepositoryId The current repository id.
     * @param repositoryIdParamName The name of the repository id query parameter.
     */
    static setTopLevelMenuItems(navbarPlugins, navbarModel, productInfo) {
        navbarPlugins.forEach((menuPlugin) => {
            menuPlugin.items
                .filter((item) => !item.parent && item.shouldShow)
                .forEach((item) => {
                if (navbarModel.hasParent(item.label)) {
                    logger.warn('Doubled parent definition: ', item);
                }
                else {
                    navbarModel.addItem(this.toMenuItemModel(item, undefined, productInfo, item.children));
                }
            });
        });
    }
    static setSubmenuItems(navbarPlugins, navbarModel, productInfo) {
        navbarPlugins.forEach((menuPlugin) => {
            menuPlugin.items
                .filter((item) => item.parent && item.shouldShow)
                .forEach((item) => {
                const topLevelItem = navbarModel.getTopLevelItem(item.parent);
                // Some submenu items in the external menu model have children which is unusual.
                // I'm not sure if and where these children are used. For now, I'm ignoring them.
                topLevelItem === null || topLevelItem === void 0 ? void 0 : topLevelItem.addChildren(this.toMenuItemModel(item, topLevelItem, productInfo, item.children));
            });
        });
    }
    static toMenuItemModel(item, parent, productInfo, children = []) {
        let externalLink;
        if (item.documentationHref) {
            externalLink = UriUtil.resolveDocumentationUrl(productInfo === null || productInfo === void 0 ? void 0 : productInfo.shortVersion, item.documentationHref);
        }
        const itemModel = new NavbarItemModel({
            label: item.label,
            labelKey: item.labelKey,
            href: externalLink || item.href,
            documentationHref: item.documentationHref,
            hrefFun: item.hrefFun,
            order: item.order,
            role: item.role,
            editions: item.editions,
            icon: item.icon,
            guideSelector: item.guideSelector,
            hasParent: !!parent,
            parentModel: parent,
            parent: item.parent,
            selected: false,
            shouldShow: item.shouldShow,
            testSelector: item.testSelector,
        });
        const childrenModels = children.map((childrenItem) => this.toMenuItemModel(childrenItem, itemModel, productInfo, childrenItem.children));
        itemModel.addChildren(...childrenModels);
        return itemModel;
    }
    ;
}

const ontoNavbarCss = ":host{display:block}.navbar-component{width:15rem;position:fixed;font-weight:400;z-index:1010;margin:0;padding:0;-moz-transition:width 0.2s ease-in;-o-transition:width 0.2s ease-in;-webkit-transition:width 0.2s ease-in;transition:width 0.2s ease-in;height:calc(100% - 60px);overflow-y:auto;overflow-x:hidden}@media screen and (max-height: 475px){.navbar-component.collapsed{position:absolute}}.navbar-component li{list-style:none;cursor:pointer}.navbar-component li a{text-decoration:none}.navbar-component li a.sub-menu-link:not([href=\"\"]):not([tabindex]):hover{text-decoration:none !important}.navbar-component .sub-menu-item a.sub-menu-link:not([href]) translate-label.menu-item{padding-right:3.5px}.navbar-component a.sub-menu-link:not([href]):hover .menu-item,.navbar-component a.sub-menu-link[href=\"\"]:hover .menu-item{text-decoration-line:underline !important}.navbar-component li .menu-element-root:hover,.navbar-component .sub-menu li:hover{text-decoration-line:none !important}.navbar-component li .menu-element-root:hover .menu-item-icon,.navbar-component .menu-element.open .menu-item-icon{transform:scale(1.1)}.navbar-component .menu-element.open .sub-menu .menu-item-icon{transform:scale(0.5)}.navbar-component .menu-element{position:relative}.navbar-component .menu-element-root{padding:0.8em;display:flex;align-items:center;line-height:2.5rem;position:relative;z-index:100;-moz-transition:all 0.18s ease-out;-o-transition:all 0.18s ease-out;-webkit-transition:all 0.18s ease-out;transition:all 0.18s ease-out;cursor:pointer;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.navbar-component .menu-item-icon{font-size:1.6rem;width:2.5rem;vertical-align:middle;text-align:center;transform:scale(0.9);display:inline-block;-moz-transition:all 0.18s ease-out;-o-transition:all 0.18s ease-out;-webkit-transition:all 0.18s ease-out;transition:all 0.18s ease-out;pointer-events:none}.navbar-component .menu-element-root .menu-item{pointer-events:none}.navbar-component .chevron{margin-left:auto;font-size:1rem;transition:all 0.2s ease-in;pointer-events:none;color:var(--gw-sidenav-menuitem-icon-second-color)}.navbar-component .chevron.open{transform:rotate(90deg)}.navbar-component :not(.brand) .menu-element-root{font-size:1.1rem}.navbar-component .brand a{display:block;position:relative;z-index:5}.navbar-component .sub-menu{position:relative;padding:0;z-index:110}.navbar-component .sub-menu li{display:none}.navbar-component .sub-menu li a{padding:0.5em 0.8em 0.5em 1.3em;display:block}.navbar-component .sub-menu li.active a{font-weight:500}.navbar-component .menu-element.open ul li{display:block}.navbar-component.collapsed{width:4.375rem;overflow:visible;height:auto}.navbar-component.collapsed .menu-element.open .sub-menu{position:absolute;top:0;left:4.375rem;width:15rem}.navbar-component.collapsed .menu-element .menu-item,.navbar-component.collapsed .menu-element .sub-menu li{display:none}.navbar-component.collapsed .menu-element.open .menu-item,.navbar-component.collapsed .menu-element.open .sub-menu li{display:block}.navbar-component.collapsed .menu-element.open .menu-element-root .menu-item{display:none}.navbar-component.collapsed .menu-element.open .sub-menu-item .sub-menu-link{background-color:var(--gw-sidenav-submenuitem-open-background)}.navbar-component.collapsed .menu-element-root{overflow:visible}.navbar-component .menu-element.open ul li.submenu-title,.navbar-component .submenu-title{display:none}.navbar-component.collapsed .menu-element.open ul li.submenu-title{display:block;font-size:1.2em;font-weight:500;text-overflow:ellipsis;overflow:hidden;padding:0.5em 0.8rem 0.7em 0.8rem;background-color:var(--gw-sidenav-submenuitem-open-background)}.navbar-component.collapsed .menu-element.open .sub-menu.align-bottom{bottom:0;top:auto}.navbar-component.collapsed .menu-element ul:before{display:none}.navbar-toggle{padding:0.3em 0}.toggle-menu{display:flex;flex-direction:column;align-items:flex-end;font-size:1em;line-height:1.5;padding:0 0.3em;z-index:101;cursor:pointer;background-color:var(--gw-sidenav-togglebutton-background);color:var(--gw-sidenav-togglebutton-color)}.toggle-menu:hover{color:var(--gw-sidenav-togglebutton-hover-color);background-color:var(--gw-sidenav-togglebutton-hover-background)}.toggle-menu [class^=icon-]{transition:all 0.2s ease-in;display:inline-block}.toggle-menu:hover [class^=icon-]{transform:scale(1.1)}.navbar-component{background-color:var(--gw-sidenav-background)}.navbar-component .menu-element .menu-element-root:not(.active){background-color:var(--gw-sidenav-menuitem-background);color:var(--gw-sidenav-menuitem-color)}.navbar-component .menu-element .menu-element-root .menu-item-icon,.navbar-component .menu-element .menu-element-root .menu-item{color:var(--gw-sidenav-menuitem-icon-color)}.navbar-component .menu-element .menu-element-root:hover,.navbar-component .menu-element .menu-element-root:hover .menu-item{background-color:var(--gw-sidenav-menuitem-hover-background);color:var(--gw-sidenav-menuitem-hover-color)}.navbar-component .menu-element .menu-element-root:hover .menu-item-icon{color:var(--gw-sidenav-menuitem-hover-icon-color)}.navbar-component .menu-element:not(.open):has(.menu-element-root.active){background-color:var(--gw-sidenav-menuitem-selected-background);color:var(--gw-sidenav-menuitem-selected-color);border-right:0.25em solid var(--gw-border-color-primary)}.navbar-component .menu-element .menu-element-root.active .menu-item,.navbar-component .menu-element .menu-element-root.active .menu-item-icon{color:var(--gw-sidenav-menuitem-selected-color)}.navbar-component .menu-element .menu-element-root.active .menu-item{color:var(--gw-sidenav-menuitem-selected-icon-color)}.navbar-component .menu-element.open,.navbar-component .menu-element.open .menu-element-root{background-color:var(--gw-sidenav-menuitem-open-background);color:var(--gw-sidenav-menuitem-open-color)}.navbar-component .menu-element:has(.menu-element-root.active) .menu-item-icon,.navbar-component .menu-element:has(.menu-element-root.active) .menu-item{color:var(--gw-sidenav-menuitem-selected-icon-color)}.navbar-component .menu-element .sub-menu-item .menu-item{color:var(--gw-sidenav-submenuitem-color);font-weight:400}.navbar-component .menu-element .sub-menu-item:hover .menu-item{color:var(--gw-sidenav-submenuitem-hover-color)}.navbar-component .menu-element .sub-menu-item.active{color:var(--gw-sidenav-submenuitem-selected-color);background-color:var(--gw-sidenav-submenuitem-selected-background);border-right:0.25em solid var(--gw-border-color-primary)}.navbar-component .menu-element .sub-menu-item.active .menu-item{color:var(--gw-sidenav-submenuitem-selected-color)}";

const labelKeys = {
    EXPAND: 'menu.buttons.expand',
    COLLAPSE: 'menu.buttons.collapse',
};
const OntoNavbar = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.navbarToggled = createEvent(this, "navbarToggled");
        this.productInfoContextService = service(ProductInfoContextService);
        this.repositoryContextService = service(RepositoryContextService);
        this.subscriptions = new SubscriptionList();
        this.resizeHandler = () => this.adjustAllSubmenus(this.hostElement);
        this.SUBMENU_VERTICAL_MARGIN = 8;
        this.MIN_SUBMENU_HEIGHT = 100;
        this.labels = {
            [labelKeys.EXPAND]: TranslationService.translate(labelKeys.EXPAND),
            [labelKeys.COLLAPSE]: TranslationService.translate(labelKeys.COLLAPSE),
        };
        /**
         * Flag indicating whether the navbar is collapsed in result of toggle action initiated by the user. This is needed
         * in cases where the browser window is resized which is an operation that should not override the user's choice
         * regarding the navbar collapsed state, e.g. if the user has manually collapsed the navbar and then resizes the
         * window, the navbar should remain collapsed.
         */
        this.isCollapsedByUser = false;
        this.isFirstRepositoryChange = true;
        /**
         * Controls the expanded/collapsed state of the navbar.
         */
        this.isCollapsed = false;
    }
    navbarCollapsedChange(collapsed) {
        this.isCollapsed = !collapsed;
        if (this.isCollapsed && !this.isCollapsedByUser) {
            this.expandNavbar();
        }
        else {
            this.collapseNavbar();
        }
        this.navbarToggled.emit(new NavbarToggledEvent(this.isCollapsed));
    }
    menuItemsChanged(menuItems) {
        this.init(menuItems);
    }
    init(menuItems) {
        const selectedRepository = this.repositoryContextService.getSelectedRepository();
        const internalModel = NavbarService.map(menuItems || [], this.productInfo, selectedRepository === null || selectedRepository === void 0 ? void 0 : selectedRepository.id, REPOSITORY_ID_PARAM);
        internalModel.initSelected(getCurrentRoute());
        this.menuModel = internalModel;
    }
    select(event, menuItem) {
        event.preventDefault();
        this.clearAllOpenedSubmenuStyles();
        // Skip navigation when the selected item is a parent menu because it has no associated navigation.
        if (!menuItem.hasSubmenus()) {
            if (event.ctrlKey) {
                openInNewTab(menuItem.href);
            }
            else {
                navigate(menuItem.href);
            }
        }
        if (menuItem.children.length) {
            if (!menuItem.open) {
                this.menuModel.closeOpened();
                this.menuModel.open(menuItem);
                if (this.menuModel.hasSelectedSubmenu(menuItem)) {
                    this.menuModel.deselectItem(menuItem);
                }
            }
            else {
                this.menuModel.closeAll();
                if (this.menuModel.hasSelectedSubmenu(menuItem)) {
                    this.menuModel.selectItem(menuItem);
                }
            }
        }
        else {
            this.menuModel.closeOtherParents(menuItem);
        }
        // When the navbar is collapsed then find if the selected item has active children and mark the item as selected
        // to allow it to be highlighted in the collapsed state.
        if (this.isCollapsed && this.menuModel.isParentOpened(menuItem)) {
            this.menuModel.closeOpened();
        }
        this.refreshNavbar();
        this.adjustAllSubmenus(this.hostElement);
    }
    subscribeToNavigationEnd() {
        this.subscriptions.add(service(EventService).subscribe(EventName.NAVIGATION_END, () => {
            this.selectItemByUrl();
        }));
    }
    selectItemByUrl() {
        if (!this.menuModel) {
            return;
        }
        this.menuModel.deselectAll();
        this.menuModel.closeAll();
        if (!isHomePage()) {
            this.menuModel.initSelected(getCurrentRoute());
        }
        this.refreshNavbar();
        this.adjustAllSubmenus(this.hostElement);
    }
    toggleNavbar() {
        if (!this.isCollapsed) {
            this.isCollapsedByUser = true;
            this.menuModel.highlightSelected();
            this.menuModel.closeOpened();
            this.collapseNavbar();
            this.clearAllOpenedSubmenuStyles();
        }
        else {
            this.isCollapsedByUser = false;
            this.menuModel.expandSelected();
            this.menuModel.unhighlightSelected();
            this.expandNavbar();
            this.clearAllOpenedSubmenuStyles();
        }
        this.refreshNavbar();
        this.adjustAllSubmenus(this.hostElement);
        this.navbarToggled.emit(new NavbarToggledEvent(this.isCollapsed));
    }
    collapseNavbar() {
        this.hostElement.querySelector('.navbar-component').classList.add('collapsed');
        this.isCollapsed = true;
    }
    expandNavbar() {
        if (!this.isCollapsedByUser) {
            this.hostElement.querySelector('.navbar-component').classList.remove('collapsed');
            this.isCollapsed = false;
        }
    }
    refreshNavbar() {
        var _a;
        if (!((_a = this.menuModel) === null || _a === void 0 ? void 0 : _a.items)) {
            return;
        }
        this.menuModel = new NavbarModel(this.menuModel.items);
    }
    onLanguageChanged() {
        this.refreshNavbar();
    }
    onTranslate(key) {
        this.subscriptions.add(TranslationService.onTranslate(key, [], (translation) => {
            this.labels[key] = translation;
            this.onLanguageChanged();
        }));
    }
    toggleNavbarHandler() {
        return () => this.toggleNavbar();
    }
    /**
     * Adjust the max height of a submenu to ensure it fits within the viewport.
     * The submenu will be positioned either below or above its parent menu item based on available space.
     * @param sub The submenu element to adjust.
     * @param margin Margin in pixels to apply when calculating available space. This ensures some space between the
     * submenu and the viewport edge.
     */
    adjustSubmenuMaxHeight(sub, margin = this.SUBMENU_VERTICAL_MARGIN) {
        if (!sub || typeof sub.getBoundingClientRect !== 'function') {
            return;
        }
        const parentElement = sub.closest('.menu-element');
        if (!parentElement) {
            return;
        }
        const subRect = sub.getBoundingClientRect();
        const parentRect = parentElement.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        // Calculate available space above and below the parent menu item
        const spaceAbove = parentRect.top - margin + parentRect.height;
        const spaceBelow = viewportHeight - parentRect.bottom + parentRect.height - margin;
        // Determine optimal positioning and max height
        let maxHeight;
        let shouldAlignBottom = false;
        if (spaceBelow >= subRect.height) {
            // Enough space below - align to top of parent
            maxHeight = spaceBelow;
        }
        else if (spaceAbove >= subRect.height) {
            // Not enough space below but enough above - align to bottom of parent
            maxHeight = spaceAbove;
            shouldAlignBottom = true;
        }
        else {
            // Not enough space in either direction - use larger space and make scrollable
            if (spaceBelow > spaceAbove) {
                maxHeight = spaceBelow;
                shouldAlignBottom = false;
            }
            else {
                maxHeight = spaceAbove;
                shouldAlignBottom = true;
            }
        }
        // Apply positioning
        if (shouldAlignBottom) {
            sub.style.bottom = '0';
            sub.style.top = 'auto';
        }
        else {
            sub.style.top = '0';
            sub.style.bottom = 'auto';
        }
        sub.style.maxHeight = `${Math.max(this.MIN_SUBMENU_HEIGHT, maxHeight)}px`;
        sub.style.overflowY = 'auto';
    }
    /**
     * Adjust all submenus that are currently open.
     * @param host The host element containing the navbar.
     * @param margin Margin in pixels to apply when calculating available space. This ensures some space between the
     * submenu and the viewport edge.
     */
    adjustAllSubmenus(host, margin = this.SUBMENU_VERTICAL_MARGIN) {
        // run after paint so DOM is in final state
        requestAnimationFrame(() => {
            if (!host || typeof host.querySelectorAll !== 'function') {
                return;
            }
            this.getAllOpenedSubmenus(host).forEach((s) => this.adjustSubmenuMaxHeight(s, margin));
        });
    }
    getAllOpenedSubmenus(host) {
        return Array.from(host.querySelectorAll('.navbar-component.collapsed .menu-element.open .sub-menu'));
    }
    getAllSubmenus(host) {
        return Array.from(host.querySelectorAll('.navbar-component .menu-element .sub-menu'));
    }
    clearAllOpenedSubmenuStyles() {
        this.getAllSubmenus(this.hostElement).forEach((s) => {
            s.style.maxHeight = '';
            s.style.overflowY = '';
            s.style.top = '';
            s.style.bottom = '';
        });
    }
    // ========================
    // Lifecycle methods
    // ========================
    componentWillLoad() {
        this.init(this.menuItems);
    }
    connectedCallback() {
        this.subscribeToNavigationEnd();
        this.subscribeToProductInfoChanges();
        this.subscribeToRepositoryChange();
        // subscribe to language change events for each label
        this.onTranslate(labelKeys.EXPAND);
        this.onTranslate(labelKeys.COLLAPSE);
        window.addEventListener('resize', this.resizeHandler);
    }
    disconnectedCallback() {
        this.subscriptions.unsubscribeAll();
        window.removeEventListener('resize', this.resizeHandler);
    }
    handleSelectMenuItem(item) {
        return (event) => {
            this.select(event, item);
        };
    }
    render() {
        if (!this.menuModel) {
            return;
        }
        return (h(Host, null, h("ul", { class: "navbar-component" }, h("li", { class: "navbar-toggle" }, h("a", { class: "toggle-menu no-underline", title: this.isCollapsed ? this.labels[labelKeys.EXPAND] : this.labels[labelKeys.COLLAPSE], onClick: this.toggleNavbarHandler() }, h("i", { class: `chevron ${this.isCollapsed ? 'ri-arrow-right-s-line' : 'ri-arrow-left-s-line'}` }))), this.menuModel.items.map((item) => (h("li", { key: item.labelKey, class: { 'menu-element': true, 'open': item.open }, "data-test": item.testSelector, "guide-selector": item.guideSelector }, item.children.length > 0 &&
            h(Fragment, null, h("div", { class: { 'menu-element-root': true, 'active': item.selected }, onClick: this.handleSelectMenuItem(item) }, h("span", { class: `menu-item-icon ${item.icon}` }), "\u00A0", h("translate-label", { class: "menu-item", labelKey: item.labelKey }), !this.isCollapsed && h("i", { class: `chevron ri-arrow-right-s-line ${item.open ? ' open' : ''}` })), h("ul", { class: "sub-menu" }, h("li", { key: item.labelKey, class: "submenu-title" }, h("translate-label", { labelKey: item.labelKey })), item.children.map((submenu) => (h("li", { key: submenu.labelKey, class: { 'sub-menu-item': true, 'active': submenu.selected }, "data-test": submenu.testSelector, "guide-selector": submenu.guideSelector }, submenu.documentationHref ?
                h("a", { class: "sub-menu-link external-link", href: submenu.href, target: "_blank", rel: "noopener noreferrer" }, h("translate-label", { class: "menu-item", labelKey: submenu.labelKey }), submenu.icon &&
                    h("span", { class: `text-muted ${submenu.icon}` }))
                :
                    h("a", { class: "sub-menu-link", href: submenu.href, onClick: this.handleSelectMenuItem(submenu) }, h("translate-label", { class: "menu-item", labelKey: submenu.labelKey }), submenu.icon &&
                        h("span", { class: `text-muted ${submenu.icon}` }))))))), item.children.length === 0 &&
            h("a", { class: { 'menu-element-root': true, 'active': item.selected }, href: item.href, onClick: this.handleSelectMenuItem(item) }, h("span", { class: `menu-item-icon ${item.icon}` }), "\u00A0", h("translate-label", { class: "menu-item", labelKey: item.labelKey }))))))));
    }
    subscribeToProductInfoChanges() {
        this.subscriptions.add(this.productInfoContextService.onProductInfoChanged((productInfo) => this.productInfo = productInfo));
    }
    subscribeToRepositoryChange() {
        this.subscriptions.add(this.repositoryContextService.onSelectedRepositoryChanged(() => {
            if (this.isFirstRepositoryChange) {
                this.isFirstRepositoryChange = false;
                return;
            }
            this.init(this.menuItems);
        }));
    }
    get hostElement() { return getElement(this); }
    static get watchers() { return {
        "navbarCollapsed": ["navbarCollapsedChange"],
        "menuItems": ["menuItemsChanged"]
    }; }
};
OntoNavbar.style = ontoNavbarCss;

export { OntoDeprecationBanner as onto_deprecation_banner, OntoFooter as onto_footer, OntoHeader as onto_header, OntoLoader as onto_loader, OntoNavbar as onto_navbar };
